import React from 'react'
import {Link} from 'react-router-dom'

interface BreadcrumbItem {
  label: string
  path?: string
  active: boolean
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[]
}

const Breadcrumbs = ({items}: BreadcrumbsProps) => {
  return (
    <div className="text-sm breadcrumbs mb-2">
      <ul>
        {items.map(({label, path, active}: BreadcrumbItem) => {
          return (
            <li key={label}>
              {active ? (
                label
              ) : (
                <Link className="link" to={path}>
                  {label}
                </Link>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Breadcrumbs
